import React from 'react'

//styles
import './Header.css'

function Header() {
  return <img className="authLayoutHeaderImage" src="/images/playbackLogo.png" />
}

export default Header
